export default () => import(/* webpackChunkName: 'coffee/activities/harmony/harmony-tab' */ './HarmonyTab');
